// extracted by mini-css-extract-plugin
module.exports = {"softwarePriceSection":"styles_softwarePriceSection__DqfOC","contentWrapper":"styles_contentWrapper__pHAY3"};